export default "__VITE_ASSET__Cwvmnoja__"